export default "__VITE_ASSET__d3511471__"